import { array, string } from 'yup'
import { safify } from '../utils/safify'

export const seoWords = array()
  .of(string())
  .default([])
  .meta({
    label: 'What SEO keywords should be included?',
    snippets: true,
    autoFill: true,
  })
  .transform(safify)
